import styled from "@emotion/styled";
import COLORS from "common/Colors";
import { Button } from "antd";

export const ButtonOutlined = styled(Button)`
  padding: 5px 20px;
  border: 1px solid #000000;
  border-radius: 5px;
  background: transparent;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  margin: 10px;

  &:hover {
    border: 1px solid #000000;
    background: #f1f3f4;
    color: #000000;
  }
  &:focus {
    border: 1px solid #000000;
    background: #f1f3f4;
    color: #000000;
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

export const ButtonLink = styled(Button)`
  padding: 5px 20px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: ${COLORS.TEXT.SECONDARY};
  white-space: nowrap;
  outline: none;
  font-weight: 600;

  &:hover {
    outline: none;
    color: ${COLORS.TEXT.SECONDARY};
  }
  &:focus {
    outline: none;
  }
`;

export const ButtonFilled = styled(Button)`
  margin: 10px;
  padding: 5px 20px;
  border: none;
  border-radius: 5px;
  max-height: 50px;
  background: ${COLORS.PRIMARY};
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  &:hover {
    background: ${COLORS.PRIMARY};
    color: #000000;
  }
  &:focus {
    background: ${COLORS.PRIMARY};
    color: #000000;
  }
`;
